import { render, staticRenderFns } from "./restrict.vue?vue&type=template&id=85e5c36e&"
import script from "./restrict.vue?vue&type=script&lang=js&"
export * from "./restrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports